import { toast, ToastOptions, TypeOptions } from 'react-toastify';
import { CheckIcon, IconType, InfoIcon, WarningIcon } from 'components/icons/icons';
import { NotificationContent } from './NotificationContent';

const defaultOptions = {
	hideProgressBar: true,
	draggable: false,
	closeOnClick: true
}

type NotificationArg = {
	message: string
	i18nArgs?: string[]
	route?: string
	options?: ToastOptions
}

type Notification = {
	info: (arg: NotificationArg) => void
	success: (arg: NotificationArg) => void
	warning: (arg: NotificationArg) => void
	error: (arg: NotificationArg) => void
}

const createNotification = (type: TypeOptions, Icon: IconType, autoClose = true) => {
	return ({ options, ...props }: NotificationArg) => {
		toast(
			<NotificationContent {...props} Icon={Icon} />,
			{
				...defaultOptions,
				type,
				icon: false,
				autoClose: autoClose ? 5000 : false,
				...options
			}
		);
	}
}

export const notification: Notification = {
	info: createNotification('info', InfoIcon),
	success: createNotification('success', CheckIcon),
	warning: createNotification('warning', WarningIcon, false),
	error: createNotification('error', WarningIcon, false)
}
